import { Rec } from "./Rec";

import type { ICategoryRec, IItemRec, IItemsRec, IUserRec } from "./types";

export class UserRec extends Rec {
  constructor({ call_type, limit, offset }: IUserRec) {
    super({
      call_type,
      limit,
      offset,
    });
  }
}

// (단일) 상품 기반 추천
export class ItemRec extends Rec {
  constructor({ call_type, item_id, limit, offset }: IItemRec) {
    super({
      call_type,
      item_id,
      limit,
      offset,
    });
  }
}

export class ItemsRec extends Rec {
  constructor({ call_type, item_ids, limit, offset }: IItemsRec) {
    super({
      call_type,
      item_ids,
      limit,
      offset,
    });
  }
}

export class CategoryRec extends Rec {
  constructor({ call_type, category_id, limit, offset }: ICategoryRec) {
    super({
      call_type,
      category_id,
      limit,
      offset,
    });
  }
}
